const { getEnv } = require('./getEnv')

const { BACKUP_APP } = getEnv()

const allowBackupApp = BACKUP_APP === 't'

module.exports = { allowBackupApp }
